var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwentyfour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f2f60;\n      }\n\n      .cls-2 {\n        fill: #e9e8e9;\n      }\n\n      .cls-3 {\n        fill: #d3d3d3;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M854.78,732.92h24.26c43.23,0,82.73-24.45,102.01-63.13-21.52.03-41.58-10.92-53.18-29.06l-9.96-45.63v-51.58c0-61.02-49.47-110.49-110.49-110.49s-110.49,49.47-110.49,110.49v51.58l-9.93,45.63c-11.62,18.12-31.68,29.08-53.21,29.06,19.28,38.68,58.77,63.13,101.99,63.13h118.98Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M927.86,640.72l-9.94-45.63v-51.58c-.74-61.02-50.8-109.88-111.82-109.14-56.92.69-104,44.52-108.76,101.24,49.57,99.03,149.73,162.62,260.43,165.35,9.5-8.97,17.38-19.53,23.28-31.19-21.53.04-41.59-10.92-53.19-29.06h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M996.83,1032.81v-189.4c0-28.79-16.95-54.88-43.26-66.58l-98.79-43.91v-31.57h-94.7v31.57l-98.79,43.91c-26.31,11.69-43.26,37.79-43.26,66.58v189.4h378.81Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M996.83,843.4c0-28.79-16.95-54.88-43.26-66.58l-98.79-43.91v-31.57h-94.7v31.57l-98.79,43.91c-1.25.55-2.37,1.29-3.57,1.91-5.3,10.23-8.08,21.58-8.13,33.1,0,104.61,84.8,189.4,189.4,189.4h157.84v-157.84Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M807.43,843.4c65.9,0,121.31-29.99,137.32-70.47l-89.97-40.01v-31.57h-94.7v31.57l-89.97,40.01c16,40.56,71.42,70.47,137.32,70.47Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M854.78,732.92v-12.91c-29.22,17.22-65.48,17.22-94.7,0v12.91l-89.97,40.01c16,40.56,71.42,70.47,137.32,70.47s121.31-29.99,137.32-70.47l-89.97-40.01Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M728.51,590.86h-15.78c-17.43,0-31.57,14.13-31.57,31.57s14.13,31.57,31.57,31.57h17.36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M886.35,590.86h15.78c17.43,0,31.57,14.13,31.57,31.57s-14.13,31.57-31.57,31.57h-17.36"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M712.72,1032.81h-31.57v-72.84c-10.25-12.44-15.83-28.07-15.78-44.19v-2.71c-.05-18.49,7.3-36.24,20.41-49.28l15.78-15.78,22.32,22.32-15.78,15.78c-7.17,7.14-11.19,16.85-11.16,26.97v2.71c-.03,10.11,3.99,19.81,11.16,26.93,2.96,2.96,4.63,6.98,4.62,11.17v78.92Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M933.7,1032.81h-31.57v-78.92c0-4.19,1.66-8.21,4.62-11.17,7.17-7.12,11.19-16.82,11.16-26.93v-2.71c.03-10.11-3.99-19.81-11.16-26.93l-15.78-15.78,22.32-22.32,15.78,15.78c13.11,13.03,20.46,30.76,20.41,49.25v2.71c.05,16.12-5.54,31.75-15.78,44.19v72.83Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.65,702.01v30.9c0,26.15,21.2,47.35,47.35,47.35s47.35-21.2,47.35-47.35v-31.57l-94.7.66Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.19,1032.81v-189.4c0-28.6-17.41-54.31-43.96-64.93l-113.88-45.55h-94.7l-113.88,45.55c-26.55,10.62-43.96,36.34-43.96,64.93v189.4h410.38Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.19,843.4c0-28.6-17.41-54.31-43.96-64.93l-113.88-45.55h-94.7l-113.88,45.55c-1.8.73-3.46,1.69-5.19,2.54-4.73,9.59-7.19,20.13-7.2,30.83,0,104.61,84.8,189.4,189.4,189.4h189.4v-157.84Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.94,890.75h31.57v142.05h-31.57v-142.05Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.51,952.72v-61.97h-31.57v25.7c8.94,13.38,19.55,25.57,31.57,36.27Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.48,890.75h31.57v110.49h-31.57v-110.49Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.51,595.09v-98.93c0-34.87,28.27-63.13,63.13-63.13h63.13c26.15,0,47.35,21.2,47.35,47.35,26.15,0,47.35,21.2,47.35,47.35v67.38"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.48,527.73c0-26.15-21.2-47.35-47.35-47.35,0-26.15-21.2-47.35-47.35-47.35h-63.13c-8.94.02-17.76,1.96-25.89,5.68-3.72,8.12-5.66,16.95-5.68,25.89,0,54.64,44.29,98.93,98.93,98.93h90.47v-35.8Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.08,590.86h-15.78c-17.43,0-31.57,14.13-31.57,31.57s14.13,31.57,31.57,31.57h17.36"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M333.92,590.86h15.78c17.43,0,31.57,14.13,31.57,31.57s-14.13,31.57-31.57,31.57h-17.36"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M333.92,575.08v63.13c0,43.59-35.33,78.92-78.92,78.92s-78.92-35.33-78.92-78.92v-63.13h44.79c29.81,0,56.27-19.07,65.69-47.35l47.35,47.35Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.65,723.23v9.69c0,26.15,21.2,47.35,47.35,47.35s47.35-21.2,47.35-47.35v-9.69c-30.25,12.92-64.46,12.92-94.7,0Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.48,890.75h31.57v142.05h-31.57v-142.05Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.87,590.86h-44.79v47.35c0,43.59,35.33,78.92,78.92,78.92s78.92-35.33,78.92-78.92v-47.35l-47.35-47.35c-9.42,28.28-35.89,47.35-65.69,47.35Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M381.27,1032.81v-78.92c0-52.3,42.4-94.7,94.7-94.7h94.7c52.3,0,94.7,42.4,94.7,94.7v78.92h-284.11Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M665.37,953.89c0-52.3-42.4-94.7-94.7-94.7h-94.7c-17.38,0-34.42,4.82-49.23,13.91-9.09,14.81-13.9,31.85-13.91,49.23,0,43.59,35.33,78.92,78.92,78.92h173.62v-47.35Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M475.97,843.4v15.78c0,26.15,21.2,47.35,47.35,47.35s47.35-21.2,47.35-47.35v-15.78h-94.7Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M476.49,864.4c2.77,25.86,25.99,44.58,51.85,41.81,22.04-2.36,39.45-19.77,41.81-41.81-29.63,14.11-64.03,14.11-93.66,0h0Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M491.75,294.76v154.05c0,17.43,14.13,31.57,31.57,31.57s31.57-14.13,31.57-31.57v-154.05"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M523.32,480.38c17.43,0,31.57-14.13,31.57-31.57v-154.05h-31.57v185.62Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.73,322.54c56.96-151.9,202.17-252.54,364.4-252.54h60.39c162.23,0,307.44,100.64,364.4,252.54h-22c-35.56,0-68.76,17.77-88.48,47.35l-34.9-17.46c-18.57-9.28-39.05-14.11-59.8-14.11-20.76,0-41.23,4.83-59.8,14.11l-34.9,17.46-34.9-17.46c-18.57-9.28-39.05-14.11-59.8-14.11-20.76,0-41.23,4.83-59.8,14.11l-34.9,17.46-34.9-17.46c-18.57-9.28-39.05-14.11-59.8-14.11-20.76,0-41.23,4.83-59.8,14.11l-34.9,17.46c-19.72-29.58-52.93-47.35-88.48-47.35h-22Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.21,306.76l34.9-17.46c37.65-18.82,81.96-18.82,119.61,0l34.9,17.46,34.9-17.46c37.65-18.82,81.96-18.82,119.61,0l34.9,17.46,34.9-17.46c37.65-18.82,81.96-18.82,119.61,0l34.9,17.46c18.11-27.07,47.64-44.33,80.12-46.83-70.13-117.71-197.01-189.86-334.03-189.93h-60.39c-137.02.07-263.9,72.21-334.03,189.93,32.47,2.5,62.01,19.76,80.12,46.83h0Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M529.63,71.58l-4.59-1.58c61.47,81.96,94.7,181.65,94.7,284.11v15.78l34.9-17.36c37.65-18.84,81.96-18.84,119.61,0l34.9,17.36c-39.61-138.7-143.69-249.77-279.51-298.31h0Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M525.04,70l-4.55,1.58c-135.85,48.53-239.94,159.61-279.56,298.31l34.9-17.36c18.56-9.31,39.04-14.17,59.8-14.21,20.78.03,41.26,4.89,59.84,14.21l34.87,17.36v-15.78c0-102.45,33.23-202.14,94.7-284.11Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M529.63,71.58l-4.59-1.58c51.57,68.92,83.37,150.6,91.99,236.25l.99.51,34.9-17.46c37.65-18.82,81.96-18.82,119.61,0l6.41,3.16c-51.55-102.99-140.86-182.11-249.3-220.88h0Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M520.49,71.58c-107.61,38.48-196.4,116.69-248.14,218.59l1.72-.87c37.65-18.82,81.96-18.82,119.61,0l34.93,17.46,4.74-2.34c8.84-84.98,40.53-165.99,91.69-234.42l-4.55,1.58Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M523.32,669.78h0c43.59,0,78.92,35.33,78.92,78.92v31.57c0,43.59-35.33,78.92-78.92,78.92h0c-43.59,0-78.92-35.33-78.92-78.92v-31.57c0-43.59,35.33-78.92,78.92-78.92Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M444.4,953.89h31.57v78.92h-31.57v-78.92Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M586.46,953.89h31.57v78.92h-31.57v-78.92Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M475.97,999.66v-45.77h-31.57v31.2c9.29,7.17,20.08,12.15,31.57,14.57Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M586.46,953.89h31.57v47.35h-31.57v-47.35Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M807.43,433.03c-5.28.04-10.56.47-15.78,1.26v140.79h31.57v-140.79c-5.22-.8-10.5-1.22-15.78-1.26Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M886.35,575.08v63.13c0,43.59-35.33,78.92-78.92,78.92s-78.92-35.33-78.92-78.92v-63.13h13.21c29.81,0,56.27-19.07,65.71-47.35,9.42,28.27,35.88,47.34,65.68,47.35h13.24Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M807.43,543.51c-9.43,28.28-35.9,47.35-65.71,47.35h-13.21v47.35c0,43.59,35.33,78.92,78.92,78.92s78.92-35.33,78.92-78.92v-47.35h-13.24c-29.8,0-56.25-19.08-65.68-47.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M523.32,685.57c-43.59,0-78.92,35.33-78.92,78.92v15.78c0,43.59,35.33,78.92,78.92,78.92s78.92-35.33,78.92-78.92v-15.78c0-43.59-35.33-78.92-78.92-78.92Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwentyfour);
export default __webpack_public_path__ + "static/media/twentyfour.16cf6f77d0bed2be8f4a437e516f2c6e.svg";
export { ForwardRef as ReactComponent };